import { provideSSRWidth } from '@vueuse/core';

// iPhone-class width, below every Tailwind breakpoint: any value under the smallest one behaves
// the same, this one just names the reference mobile viewport.
const IPHONE_VIEWPORT_WIDTH = 375;

export default defineNuxtPlugin({
  name: 'ssr-width',
  setup(nuxtApp) {
    // Mobile-first: SSR and the first client render assume the smallest common viewport, then each
    // useBreakpoints/useMediaQuery consumer switches to the real viewport after mount — otherwise
    // the client evaluates matchMedia during setup and hydrates desktop variants against mobile
    // server markup.
    provideSSRWidth(IPHONE_VIEWPORT_WIDTH, nuxtApp.vueApp);
  },
});
